import { User, Megaphone, Video, PenLine } from "lucide-react";

export const PROJECT_AI_MODULES = [
  {
    id: "creator-fit",
    title: "Creator Fit",
    description: "Verify if a creator aligns with the campaign's vibe, demographics, and content style.",
    icon: User,
    phase: "Evaluation",
  },
  {
    id: "script-generation",
    title: "Script Generation",
    description: "Write a creator-native script from the brief, then revise any selected passage with AI.",
    icon: PenLine,
    phase: "Scripting",
  },
  {
    id: "script-vet",
    title: "Script Vet",
    description: "Analyze draft scripts to ensure they hit brand guidelines, key messaging, and tone.",
    icon: Megaphone,
    phase: "Scripting",
  },
  {
    id: "draft-vet",
    title: "Draft Vet",
    description: "Review submitted video drafts against the approved script and visual requirements.",
    icon: Video,
    phase: "Drafting",
  },
];
